export const allowOnlyLettersOnBeforeInput = (e: React.InputEvent<HTMLInputElement>) => {
  if (!e.data) return

  if (!/^[\p{L}\s'’-]+$/u.test(e.data)) {
    e.preventDefault()
  }
};
